import { formatJod } from "@astroplanet/shared";
import type { Locale } from "./types";

// "-u-nu-latn" keeps Latin digits in Arabic: consistent with receipts and WhatsApp messages.
const intlTag = (l: Locale) => (l === "ar" ? "ar-JO-u-nu-latn" : "en-GB");

export const money = (fils: number, withCurrency = false) => formatJod(fils, withCurrency);

export function formatTime(iso: string | Date, locale: Locale): string {
  return new Intl.DateTimeFormat(intlTag(locale), { hour: "2-digit", minute: "2-digit", hour12: true }).format(new Date(iso));
}
export function formatDate(iso: string | Date, locale: Locale): string {
  return new Intl.DateTimeFormat(intlTag(locale), { day: "2-digit", month: "short", year: "numeric" }).format(new Date(iso));
}
export function formatDateTime(iso: string | Date, locale: Locale): string {
  return `${formatDate(iso, locale)} ${formatTime(iso, locale)}`;
}

/** 3725 → "1h 02m" / "02m 05s" (en) and "1س 02د" / "02د 05ث" (ar). Uses the magnitude of negative values. */
export function formatCountdown(totalSeconds: number, locale: Locale): string {
  const s = Math.abs(Math.trunc(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const u = locale === "ar" ? { h: "س", m: "د", s: "ث" } : { h: "h", m: "m", s: "s" };
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${h}${u.h} ${pad(m)}${u.m}` : `${pad(m)}${u.m} ${pad(sec)}${u.s}`;
}

/** Picks the Arabic name when the UI is Arabic and one exists. */
export function localName(item: { name: string; nameAr?: string | null }, locale: Locale): string {
  return locale === "ar" && item.nameAr ? item.nameAr : item.name;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "")).toUpperCase() || "?";
}
